import Vue from 'vue';
import Vuex from 'vuex';
import makeCrudModule from './modules/crud';
import notifications from './modules/notifications';

import prodfileService from '../services/prodfile';
import designfileService from '../services/designfile';
import orderService from '../services/order';

import accessoryService from '../services/accessory';
import controlunitService from '../services/controlunit';
import customerService from '../services/customer';
import riskService from '../services/risk';
import designfiletypeService from '../services/designfiletype';
import industrialcomputerService from '../services/industrialcomputer';
import machineService from '../services/machine';
import materialService from '../services/material';
import nozzleService from '../services/nozzle';
import orderstateService from '../services/orderstate';
import orderactionService from '../services/orderaction';
import orderresolutionService from '../services/orderresolution';
import actiontypeService from '../services/actiontype';
import ordertypeService from '../services/ordertype';
import printingsurfaceService from '../services/printingsurface';
import printerService from '../services/printer';
import priorityService from '../services/priority';
import sectorService from '../services/sector';
import tagService from '../services/tag';
import toolrefService from '../services/toolref';
import toolheadService from '../services/toolhead';
import updatedlynxapiService from '../services/updatedlynxapi';
import verticaleService from '../services/verticale';
//user
import userService from '../services/user';
import forgotpasswordService from '../services/forgotpassword';
import connexionuserService from '../services/connexionuser';
import mediaobjectService from '../services/mediaobject';
import profilService from '../services/profil';
import profilinterfaceService from '../services/profilinterface';
import accessService from '../services/accesses';
import notificationService from '../services/notification';
import notificationuserService from '../services/notificationuser';
import notificationtypeService from '../services/notificationtype';
import securityparameterService from '../services/securityparameter';
import backupService from '../services/backup';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    notifications,
    prodfile: makeCrudModule({
      service: prodfileService
    }),
    designfile: makeCrudModule({
      service: designfileService
    }),
    order: makeCrudModule({
      service: orderService
    }),
    accessory: makeCrudModule({
      service: accessoryService
    }),
    controlunit: makeCrudModule({
      service: controlunitService
    }),
    customer: makeCrudModule({
      service: customerService
    }),
    designfiletype: makeCrudModule({
      service: designfiletypeService
    }),
    industrialcomputer: makeCrudModule({
      service: industrialcomputerService
    }),
    machine: makeCrudModule({
      service: machineService
    }),
    material: makeCrudModule({
      service: materialService
    }),
    nozzle: makeCrudModule({
      service: nozzleService
    }),
    risk: makeCrudModule({
      service: riskService
    }),
    orderstate: makeCrudModule({
      service: orderstateService
    }),
    ordertype: makeCrudModule({
      service: ordertypeService
    }),
    orderaction: makeCrudModule({
      service: orderactionService
    }),
    orderresolution: makeCrudModule({
      service: orderresolutionService
    }),
    actiontype: makeCrudModule({
      service: actiontypeService
    }),
    printingsurface: makeCrudModule({
      service: printingsurfaceService
    }),
    printer: makeCrudModule({
      service: printerService
    }),
    priority: makeCrudModule({
      service: priorityService
    }),
    sector: makeCrudModule({
      service: sectorService
    }),
    tag: makeCrudModule({
      service: tagService
    }),
    toolref: makeCrudModule({
      service: toolrefService
    }),
    toolhead: makeCrudModule({
      service: toolheadService
    }),
    updatedlynxapi: makeCrudModule({
      service: updatedlynxapiService
    }),
    user: makeCrudModule({
      service: userService
    }),
    forgotpassword: makeCrudModule({
      service: forgotpasswordService
    }),
    connexionuser: makeCrudModule({
      service: connexionuserService
    }),
    mediaobject: makeCrudModule({
      service: mediaobjectService
    }),
    profil: makeCrudModule({
      service: profilService
    }),
    profilinterface: makeCrudModule({
      service: profilinterfaceService
    }),
    accesses: makeCrudModule({
      service: accessService
    }),
    notificationuser: makeCrudModule({
      service: notificationService
    }),
    notificationtype: makeCrudModule({
      service: notificationtypeService
    }),
    notificationusersubscriber: makeCrudModule({
      service: notificationuserService
    }),
    securityparameter: makeCrudModule({
      service: securityparameterService
    }),
    backup: makeCrudModule({
      service: backupService
    }),
    verticale: makeCrudModule({
      service: verticaleService
    }),


  },
  strict: process.env.NODE_ENV !== 'production'
});

export default store;
